var r=function(n){return n.NONE="none",n}({});export{r as NoneEnum};